module.exports = __webpack_public_path__ + "static/img/bg_banner2.2554d81.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_banner2.png
// module id = CClq
// module chunks = 1